// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/pattern-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./img/icon-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/fonts/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/fonts/Rubik-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/fonts/Rubik-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 10px;
  font-family: "Rubik", sans-serif;
}

* {
  margin: 0;
  box-sizing: border-box;
}

.finder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  padding: 2rem 1.5rem 17.5rem;
  text-align: center;
  position: relative;
}
@media (min-width: 1024px) {
  .finder {
    padding: 2rem 1.5rem;
  }
}

.title {
  color: white;
  margin-bottom: 1.5rem;
  font-weight: 500;
  font-size: 3rem;
}

.search-bar {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.search-bar__input {
  width: 100%;
  max-width: 500px;
  font-size: 1.8rem;
  font-weight: 700;
  color: hsl(0, 0%, 17%);
  border: none;
  outline: none;
  padding: 1.5rem 2rem;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
}
@media (max-width: 420px) {
  .search-bar__input {
    font-size: 1.2rem;
  }
}

.search-bar__btn {
  background-color: black;
  border: none;
  outline: none;
  color: white;
  padding: 0 1.5rem;
  border-radius: 0 10px 10px 0;
  position: relative;
  cursor: pointer;
}

.search-bar__btn:hover {
  background-color: rgb(77, 77, 77);
}

.search-bar__btn-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat;
  width: 7px;
  height: 7px;
}

.info {
  width: calc(100% - 3rem);
  background-color: white;
  padding: 2rem;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 1.5rem;
  z-index: 10000;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  margin: 0 auto;
}
@media (min-width: 1024px) {
  .info {
    width: 100%;
    max-width: 1000px;
    transform: translateY(50%);
    margin-left: auto;
    margin-right: auto;
    position: relative;
    flex-direction: row;
  }
}

.info__block {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 25%;
  padding: 0 1rem;
  position: relative;
}

.info__block:not(:last-child) {
  margin-bottom: 2.5rem;
}

.info__block-subtitle {
  color: hsl(0, 0%, 59%);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  letter-spacing: 0.3rem;
}

.info__block-title {
  color: hsl(0, 0%, 17%);
  font-weight: 700;
  font-size: 2rem;
  word-wrap: break-word;
}

.map {
  min-height: calc(100vh - 310px);
}

.info__block {
  margin-bottom: 0;
  min-width: 25%;
}

.info__block::after {
  content: "";
  width: 1px;
  height: 90%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: hsla(0, 0%, 59%, 0.3);
}

.info__block:last-child::after {
  display: none;
}

.info__block-title {
  font-size: 2.4rem;
}

@font-face {
  font-family: "Rubik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("ttf");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Rubik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("ttf");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Rubik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("ttf");
  font-weight: 700;
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/style/base/_base.sass","webpack://./src/index.sass","webpack://./src/style/abstracts/_mixins.sass","webpack://./src/style/base/_fonts.sass"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gCAAA;ACCJ;;ADCA;EACI,SAAA;EACA,sBAAA;ACEJ;;ADAA;EACI,mDAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;ACGJ;ACdQ;EFMR;IAOM,oBAAA;ECKJ;AACF;;ADJA;EACI,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;ACOJ;;ADLA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oDAAA;ACQJ;;ADNA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,4BAAA;EACA,eAAA;ACSJ;AC3CQ;EFwBR;IAYM,iBAAA;ECWJ;AACF;;ADVA;EACI,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;ACaJ;;ADXA;EACI,iCAAA;ACcJ;;ADZA;EACI,0EAAA;EACA,UAAA;EACA,WAAA;ACeJ;;ADbA;EACI,wBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,oDAAA;EACA,cAAA;ACgBJ;ACtFQ;EF2DR;IAaM,WAAA;IACA,iBAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,mBAAA;ECkBJ;AACF;;ADjBA;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ACoBJ;;ADlBA;EACI,qBAAA;ACqBJ;;ADnBA;EACI,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;ACsBJ;;ADpBA;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ACuBJ;;ADrBA;EACI,+BAAA;ACwBJ;;ADtBA;EACI,gBAAA;EACA,cAAA;ACyBJ;;ADvBA;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,uCAAA;AC0BJ;;ADxBA;EACI,aAAA;AC2BJ;;ADzBA;EACI,iBAAA;AC4BJ;;AE1JA;EACC,oBAAA;EACA,0DAAA;EACA,gBAAA;EACA,kBAAA;AF6JD;AE3JA;EACC,oBAAA;EACA,0DAAA;EACA,gBAAA;EACA,kBAAA;AF6JD;AE3JA;EACC,oBAAA;EACA,0DAAA;EACA,gBAAA;EACA,kBAAA;AF6JD","sourcesContent":[":root\r\n    font-size: 10px\r\n    font-family: 'Rubik', sans-serif\r\n\r\n*\r\n    margin: 0\r\n    box-sizing: border-box\r\n\r\n.finder\r\n    background: url(./img/pattern-bg.png)\r\n    background-size: cover\r\n    padding: 2rem 1.5rem 17.5rem\r\n    text-align: center\r\n    position: relative\r\n    @include respond(breakpoint-1024)\r\n      padding: 2rem 1.5rem\r\n\r\n.title\r\n    color: white\r\n    margin-bottom: 1.5rem\r\n    font-weight: 500\r\n    font-size: 3rem\r\n\r\n.search-bar\r\n    display: flex\r\n    justify-content: center\r\n    margin-bottom: 2rem\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))\r\n\r\n.search-bar__input\r\n    width: 100%\r\n    max-width: 500px\r\n    font-size: 1.8rem\r\n    font-weight: 700\r\n    color: hsl(0, 0%, 17%)\r\n    border: none\r\n    outline: none\r\n    padding: 1.5rem 2rem\r\n    border-radius: 10px 0 0 10px\r\n    cursor: pointer\r\n    @include respond(breakpoint-420)\r\n      font-size: 1.2rem\r\n\r\n.search-bar__btn\r\n    background-color: black\r\n    border: none\r\n    outline: none\r\n    color: white\r\n    padding: 0 1.5rem\r\n    border-radius: 0 10px 10px 0\r\n    position: relative\r\n    cursor: pointer\r\n\r\n.search-bar__btn:hover\r\n    background-color: rgb(77, 77, 77)\r\n\r\n.search-bar__btn-icon\r\n    background: url(./img/icon-arrow.svg) center/cover no-repeat\r\n    width: 7px\r\n    height: 7px\r\n\r\n.info\r\n    width: calc(100% - 3rem)\r\n    background-color: white\r\n    padding: 2rem\r\n    border-radius: 15px\r\n    display: flex\r\n    flex-direction: column\r\n    position: absolute\r\n    left: 1.5rem\r\n    z-index: 10000\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))\r\n    margin: 0 auto\r\n    @include respond(breakpoint-1024)\r\n      width: 100%\r\n      max-width: 1000px\r\n      transform: translateY(50%)\r\n      margin-left: auto\r\n      margin-right: auto\r\n      position: relative\r\n      flex-direction: row\r\n\r\n.info__block\r\n    flex-grow: 1\r\n    flex-shrink: 0\r\n    flex-basis: 25%\r\n    padding: 0 1rem\r\n    position: relative\r\n\r\n.info__block:not(:last-child)\r\n    margin-bottom: 2.5rem\r\n\r\n.info__block-subtitle\r\n    color: hsl(0, 0%, 59%)\r\n    text-transform: uppercase\r\n    font-weight: 700\r\n    font-size: 1.2rem\r\n    margin-bottom: 1.5rem\r\n    letter-spacing: 0.3rem\r\n\r\n.info__block-title\r\n    color: hsl(0, 0%, 17%)\r\n    font-weight: 700\r\n    font-size: 2rem\r\n    word-wrap: break-word\r\n\r\n.map\r\n    min-height: calc(100vh - 310px)\r\n    \r\n.info__block\r\n    margin-bottom: 0\r\n    min-width: 25%\r\n  \r\n.info__block::after\r\n    content: ''\r\n    width: 1px\r\n    height: 90%\r\n    position: absolute\r\n    top: 0\r\n    right: 0\r\n    background-color: hsla(0, 0%, 59%, 0.3)\r\n  \r\n.info__block:last-child::after\r\n    display: none\r\n  \r\n.info__block-title\r\n    font-size: 2.4rem",":root {\n  font-size: 10px;\n  font-family: \"Rubik\", sans-serif;\n}\n\n* {\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.finder {\n  background: url(./img/pattern-bg.png);\n  background-size: cover;\n  padding: 2rem 1.5rem 17.5rem;\n  text-align: center;\n  position: relative;\n}\n@media (min-width: 1024px) {\n  .finder {\n    padding: 2rem 1.5rem;\n  }\n}\n\n.title {\n  color: white;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  font-size: 3rem;\n}\n\n.search-bar {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2rem;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n\n.search-bar__input {\n  width: 100%;\n  max-width: 500px;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: hsl(0, 0%, 17%);\n  border: none;\n  outline: none;\n  padding: 1.5rem 2rem;\n  border-radius: 10px 0 0 10px;\n  cursor: pointer;\n}\n@media (max-width: 420px) {\n  .search-bar__input {\n    font-size: 1.2rem;\n  }\n}\n\n.search-bar__btn {\n  background-color: black;\n  border: none;\n  outline: none;\n  color: white;\n  padding: 0 1.5rem;\n  border-radius: 0 10px 10px 0;\n  position: relative;\n  cursor: pointer;\n}\n\n.search-bar__btn:hover {\n  background-color: rgb(77, 77, 77);\n}\n\n.search-bar__btn-icon {\n  background: url(./img/icon-arrow.svg) center/cover no-repeat;\n  width: 7px;\n  height: 7px;\n}\n\n.info {\n  width: calc(100% - 3rem);\n  background-color: white;\n  padding: 2rem;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  left: 1.5rem;\n  z-index: 10000;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n  margin: 0 auto;\n}\n@media (min-width: 1024px) {\n  .info {\n    width: 100%;\n    max-width: 1000px;\n    transform: translateY(50%);\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    flex-direction: row;\n  }\n}\n\n.info__block {\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: 25%;\n  padding: 0 1rem;\n  position: relative;\n}\n\n.info__block:not(:last-child) {\n  margin-bottom: 2.5rem;\n}\n\n.info__block-subtitle {\n  color: hsl(0, 0%, 59%);\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 1.2rem;\n  margin-bottom: 1.5rem;\n  letter-spacing: 0.3rem;\n}\n\n.info__block-title {\n  color: hsl(0, 0%, 17%);\n  font-weight: 700;\n  font-size: 2rem;\n  word-wrap: break-word;\n}\n\n.map {\n  min-height: calc(100vh - 310px);\n}\n\n.info__block {\n  margin-bottom: 0;\n  min-width: 25%;\n}\n\n.info__block::after {\n  content: \"\";\n  width: 1px;\n  height: 90%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: hsla(0, 0%, 59%, 0.3);\n}\n\n.info__block:last-child::after {\n  display: none;\n}\n\n.info__block-title {\n  font-size: 2.4rem;\n}\n\n@font-face {\n  font-family: \"Rubik\";\n  src: url(\"/src/fonts/Rubik-Regular.ttf\") format(\"ttf\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Rubik\";\n  src: url(\"/src/fonts/Rubik-Medium.ttf\") format(\"ttf\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Rubik\";\n  src: url(\"/src/fonts/Rubik-Bold.ttf\") format(\"ttf\");\n  font-weight: 700;\n  font-style: normal;\n}","@mixin respond($breakpoint)\r\n    @if $breakpoint == breakpoint-1024\r\n        @media (min-width: 1024px)\r\n            @content\r\n    @if $breakpoint == breakpoint-420\r\n        @media (max-width: 420px)\r\n            @content\r\n\r\n","@font-face\r\n\tfont-family: \"Rubik\"\r\n\tsrc: url(\"/src/fonts/Rubik-Regular.ttf\") format(\"ttf\")\r\n\tfont-weight: 400\r\n\tfont-style: normal\r\n\r\n@font-face\r\n\tfont-family: \"Rubik\"\r\n\tsrc: url(\"/src/fonts/Rubik-Medium.ttf\") format(\"ttf\")\r\n\tfont-weight: 500\r\n\tfont-style: normal\r\n\r\n@font-face\r\n\tfont-family: \"Rubik\"\r\n\tsrc: url(\"/src/fonts/Rubik-Bold.ttf\") format(\"ttf\")\r\n\tfont-weight: 700\r\n\tfont-style: normal\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
